import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography, ConfirmModal } from 'mobily-ui-library';
import { GlobalContext } from '../../../context/GlobalContext';

import { applyPromotion, applyInstallmentAPI, subsidyPatch, updateAndValidateSC, captureData } from '../../../api/api';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';
import { deleteCookies } from '../../../Utils/index';
import DeviceTNC from './DeviceTNC';

import { handleApiError } from '../../../functions/handleApiError';
import captureStructure from '../../../captureStructure.json';

import './DeviceTerms.scss';

interface Props {
    handleHeaderCancel: () => void;
}


function DeviceTerms({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, scData, cartId, productId, promotionApplied, deviceFlow, appliedInstallment, 
    subPageToDisplay: stepName, msisdn, otpValue, customerAccount, promoTypeCode, promoTypeValue, 
    promoAmount, promoActionObjectID, accessToken } = state;
    const newStackValue = customerAccount?.NewStack ? customerAccount?.NewStack : "N";
    const activeFlow = deviceFlow || sessionStorage.getItem('device-flow');
    const isSubsidyJourney = activeFlow === 'subsidy' || (!!promotionApplied && Object.keys(promotionApplied).length > 0 && (!appliedInstallment || Object.keys(appliedInstallment).length === 0));

    const { t } = useTranslation();

    const [checked, setChecked] = useState(false);

    const [commonError, setCommonError] = useState<any>(false);

    const cartItemId = scData?.offerContainer[0]?.cartItem[0]?.id ? scData?.offerContainer[0]?.cartItem[0]?.id : "";
    const ocId = scData?.offerContainer[0]?.id

    const handleCheckbox = () => {
        setChecked(prevState => !prevState)
    }

    const handleBackArrow = () => {
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceClaimPlan' } })
    }

    const updateAndValidateSCAPI = () => {
        updateAndValidateSC(cartId)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    captureDataApi(res?.data?.shoppingCart)
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setCommonError(true);
                }
            }).catch(() => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                setCommonError(true);
            })
    }

    const captureDataApi = (scData: any) => {
        const sections: any = ({
            ...captureStructure,
            steps: captureStructure?.steps.map((step: any) => ({
                ...step,
                offerContainerId: scData.offerContainer[0].id,
                options: [
                    {
                        name: 'Login',
                        value: 'Mobily number',
                        fields: [
                            {
                                name: 'Mobily number',
                                value: msisdn
                            }
                        ]
                    }
                ],
                fields: step.fields.map((field: any) => {
                    let fieldValues = field;

                    if (field.name === 'Continue As Guest') {
                        fieldValues = ({
                            ...field,
                            value: 'No'
                        })
                    } else if (field.name === 'OTP') {
                        fieldValues = ({
                            ...field,
                            value: otpValue
                        })
                    } else if (field.name === 'CustomerRelatedAcccountInquiryResponse') {
                        fieldValues = ({
                            ...field,
                            value: JSON.stringify(customerAccount)
                        })
                    } else if (field.name === 'MobilyMSISDN') {
                        fieldValues = ({
                            ...field,
                            value: '' //pass encrpty BMNumber value when using ID Number in Login
                        })
                    } else if (field.name === 'promoTypeCode') {
                        fieldValues = ({
                            ...field,
                            value: promoTypeCode
                        })
                    } else if (field.name === 'promoTypeValue') {
                        fieldValues = ({
                            ...field,
                            value: promoTypeValue
                        })
                    } else if (field.name === 'promotionTermAndCondition') {
                        fieldValues = ({
                            ...field,
                            value: 'true'
                        })
                    } else if (field.name === 'deviceInstallment') {
                        fieldValues = ({
                            ...field,
                            value: isSubsidyJourney ? 'false' : 'true'
                        })
                    } else if (field.name === 'NewStack') {
                        fieldValues = ({
                            ...field,
                            value: newStackValue
                        })
                    }

                    return fieldValues
                })
            }))

        });

        captureData(scData, [sections])
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceSubsidySuccess" } });
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    handleApiError(res, stepName);
                }
            }).catch(err => {
                handleApiError(err, stepName);
            })
    }

    const handleApplySubsidy = () => {

        dispatch({ type: "LOADER", payload: { loading: true } });

        if (isSubsidyJourney) {
            subsidyPatchAPI()
        } else {
            applyInstallmentAPIcall()
        }
    }

    const applyInstallmentAPIcall = () => {
        const isEmpty = (val: any) => val === undefined || val === null || val === '';

        if (isEmpty(scData?.id) || isEmpty(msisdn)) {
            dispatch({ type: "LOADER", payload: { loading: false } });
            return;
        }

        const req = {
            shoppingCartId: scData?.id,
            msisdn: msisdn ? msisdn?.replace(/^0/, "966") : "",
        }

        applyInstallmentAPI(req, accessToken)
            .then((res: any) => {
                if (res?.status === 200 && res?.data) {
                    updateAndValidateSCAPI()
                } else {
                    const config = Object.assign(res?.config, { serviceName: 'instalmentPatch' });
                    const response = { ...res, config }
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    handleApiError(response, stepName);
                }
            }).catch(err => {
                const config = Object.assign(err?.config, { serviceName: 'instalmentPatch' });
                const error = { ...err, config }
                handleApiError(error, stepName);
            })
    }

    const subsidyPatchAPI = () => {
        const req = {
            shoppingCartData: {
                ocId: scData.offerContainer[0]?.id,
                scId: cartId
            },
            promotionData: {
                packageId: productId,
                promotionId: promotionApplied?.id,
                signature: promotionApplied?.signature,
                actionObjectId: promoActionObjectID,
                actionValue: promoAmount,
            }
        }
        subsidyPatch(scData?.id, ocId, cartItemId)
            .then((res: any) => {
                if (res?.status === 201 && res?.data) {
                    const dutyFreeAmount = res.data.offerContainer?.[0]?.offerContainerTotalPrice?.[0]?.price?.dutyFreeAlteredAmount?.value

                    dispatch({ type: 'SET_UPDATED_PRODUCT_PRICE', payload: { updatedProductPrice: dutyFreeAmount } });
                    applyPromotion(req.shoppingCartData, req.promotionData)
                        .then((res: any) => {
                            if (res.status === 200 && res.data) {
                                updateAndValidateSCAPI();
                            } else {
                                const config = Object.assign(res?.config, { serviceName: 'applyPromotion' });
                                const response = { ...res, config }
                                dispatch({ type: "LOADER", payload: { loading: false } });
                                handleApiError(response, stepName);
                            }
                        }).catch(err => {
                            const config = Object.assign(err?.config, { serviceName: 'applyPromotion' });
                            const error = { ...err, config }
                            handleApiError(error, stepName);
                        })
                } else {
                    const config = Object.assign(res?.config, { serviceName: 'subsidyPatch' });
                    const response = { ...res, config }
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    handleApiError(response, stepName);
                }
            }).catch(err => {
                const config = Object.assign(err?.config, { serviceName: 'subsidyPatch' });
                const error = { ...err, config }
                handleApiError(error, stepName);
            })
    }

    const deviceTermsCommonError = () => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        deleteCookies('device-count');
        deleteCookies('device-scId');
        deleteCookies('device-xCoId');
        deleteCookies('device-poid');
        deleteCookies('device-journeyName');
        sessionStorage.removeItem('device-flow');
        setCommonError(false)
        window.location.reload();
    }

    return (
        <div className='DeviceTermsNCondition__Container'>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <ConfirmModal
                id="deviceTermsCommonErrorModal"
                idBtn='deviceTermsCommonErrorModalContinue'
                idCloseIcon='deviceTermsCommonErrorModalClose'
                showModal={commonError}
                title={t("something_went_wrong")}
                subTitle={t("try_again_later")}
                buttonName={t("close")}
                primaryButtonclassName=''
                onclickButton={() => { deviceTermsCommonError() }}
                showOutlineButton={false}
                onClickClose={() => { deviceTermsCommonError() }} >
            </ConfirmModal>

            <DeviceTNC />

            {/* sticky terms n condition */}
            <div className='DTNC__StickyBox'>
                <div className='STB__Container'>
                    <div className='STB__TnC'>
                        <input aria-label='checkbox' type='checkbox' onChange={handleCheckbox} className='STB__Checkbox' />
                        <Typography rtl={rtl} id="lineType-heading" className='STB__Text'>{isSubsidyJourney ? t('Accept_TermsNcondition') : t('installments_terms_conditions')}</Typography>
                    </div>
                    <Button
                        rtl={rtl}
                        className={`STB__ApplyBtn ApplyBtn_${isSubsidyJourney ? 'sub' : 'inst'}`}
                        variant={!checked ? 'disabled' : 'default'}
                        onClick={handleApplySubsidy}
                    >
                        {isSubsidyJourney ? t('Apply_Subsidy') : t('apply_installments')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default DeviceTerms